module.exports = __webpack_public_path__ + "static/media/largeRectangle.7454a471.png";